import { creditSchema } from '@billing/validation/credit';
import { Provider } from 'interfaces/provider';
import { Site } from './site';

export interface Credit {
  id: string;
  siteID: string;
  providerID: string;
  amount: string;
  date: string;
  provider: Provider;
  description: string | null;
  site: Site;
  filename: string | null;
}

export const isCredit = (obj: any): obj is Credit => {
  return creditSchema.safeParse(obj).success;
};
